import { SET_BOOKING_DETAILS, DELETE_BOOKING_DETAILS, BOOKING_DETAILS_LOADING } from '../actions/types';

export function CurrentBooking(state = {}, action){
    switch (action.type) {
        case SET_BOOKING_DETAILS:
            return Object.assign({}, action.payload, {
                filteredItinerary: action.payload.itinerary !== undefined ? action.payload.itinerary.filter(item => { return item.type !== "extend" && item.type !== "gap"}) : []
            })
        case DELETE_BOOKING_DETAILS:    
            return action.payload;
        default:
            return state;
    }
}


export function BookingLoading(state = true, action){
    switch(action.type){
        case BOOKING_DETAILS_LOADING:
            return action.payload;
        default:
            return state;
    }
}